import {Component, OnInit} from '@angular/core';
import {ListService} from '../../../services/list.service';
import {Option, Response, StaticMethods} from '../../../model/GeneralModels';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {AppSettingsService} from '../../../services/app-settings.service';
import {HealthInsuranceService} from '../../../services/health-insurance.service';
import {GeneralService} from '../../../services/general.service';

// @ts-ignore
// @ts-ignore
@Component({
  selector: 'app-basic-information',
  templateUrl: './basic-information.component.html',
  styleUrls: [
    '../../../assets/vendor/mdi-font/css/material-design-iconic-font.min.css',
    '../../../assets/Content/src/css/lib.vendor.css',
    '../../../assets/Content/src/css/lib.picker.css',
    '../../../assets/Content/src/css/ini.bime.css',
    '../../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../../assets/css/light.theme.css',
  ],
})
export class BasicInformationComponent implements OnInit {
  title = 'اطلاعات اصلی';
  cities$: Option[];
  states$: Option[];
  company$: Option[];
  requiredCompany = false;
  basicInformationForm: FormGroup = this.formBuilder.group({
    stateCode: ['', Validators.required],
    cityCode: ['', Validators.required],
    company: [''],
    agentCode: ['']
  });
  translation: any = {};

  constructor(
    private stateListService: ListService,
    private formBuilder: FormBuilder,
    private router: Router,
    private healthService: HealthInsuranceService,
    private generalService: GeneralService,
    private settings: AppSettingsService
  ) {
  }

  ngOnInit() {
    this.cities$ = [];
    this.states$ = [];
    this.company$ = [];
    this.stateListService.getStateList().subscribe(response => {
      this.states$ = [];
      this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
      for (let i = 0; i < response.data.states.length; i++) {
        this.states$[i] = new Option(response.data.states[i].persianName, response.data.states[i].stateCode);
      }
    });
    // this.generalService.getClientCompanyList('HEALTH').subscribe((response: Response) => {
    //   console.log(response)
    //   if (response.success) {
    //     this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
    //     response.data.forEach(company => {
    //       this.company$[this.company$.length] = new Option(company.label, company.value);
    //     });
    //     // console.log(this.company$);
    //     // this.getCompanyRequirement();
    //   }
    // });
  }

  // getCompanyRequirement() {
  //   if (this.company$.length === 1) {
  //     this.basicInformationForm.controls.company.setValidators([Validators.required]);
  //     this.requiredCompany = false;
  //     this.basicInformationForm.controls.company.patchValue(this.company$[0].value);
  //   } else {
  //     if (this.basicInformationForm.controls.agentCode.value) {
  //       this.basicInformationForm.controls.company.setValidators([Validators.required]);
  //       this.requiredCompany = true;
  //     } else {
  //       this.basicInformationForm.controls.company.setValidators([]);
  //       this.requiredCompany = false;
  //     }
  //   }
  // }

  onStateChange(selectedStateID) {
    this.stateListService.getCityList(parseInt(selectedStateID, 10)).subscribe((response: Response) => {
      if (!response.data.cities.length) {
        this.cities$[0] = new Option('', 'هشتگ بیمه استان انتخاب شده را پوشش نمی دهد');
      } else {
        this.cities$ = response.data.cities;
        for (let i = 0; i < response.data.cities.length; i++) {
          this.cities$[i] = new Option(response.data.cities[i].persianName, response.data.cities[i].cityCode);
        }
      }
      this.basicInformationForm.patchValue({
        cityCode: ''
      });
    });
  }

  goNext() {
    if (this.basicInformationForm.valid) {
      if (this.basicInformationForm.controls.agentCode.value) {
        this.generalService.checkAgentCode(
          this.basicInformationForm.controls.company.value,
          this.basicInformationForm.controls.agentCode.value,
          'HEALTH'
        ).subscribe((response: Response) => {
          if (response.success) {
            this.router.navigate(['/health/family/new-request'], {state: {basicInformation: this.basicInformationForm.value}});
          }
        });
      } else {
        this.router.navigate(['/health/family/new-request'], {state: {basicInformation: this.basicInformationForm.value}});
      }
    }
  }

  onAgentCodeChange() {
    if (this.basicInformationForm.controls.agentCode.value) {
      this.basicInformationForm.controls.company.setValidators([Validators.required]);
      this.requiredCompany = true;
    } else {
      // this.getCompanyRequirement();
    }
  }
}
